import { Task } from "../types";

const toClientLocalDate = (date: Date): Date => {
  // it's already in the client's local time (autoconversion)
  return date;
  // const clientOffset = new Date().getTimezoneOffset();
  // const localDate = new Date(date.getTime() - clientOffset * 60000);
  // return localDate;
};

const toUTCDate = (date: Date): Date => {
  const offset = date.getTimezoneOffset();
  return new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes() + offset,
    date.getSeconds()
  ));
};

export const toTaskDTO = (task: any): Task => ({
  id: task.id,
  datetimePlanned: toClientLocalDate(new Date(task.planned)),
  datetimePublished: task.published ? toClientLocalDate(new Date(task.published)) : null,
  actionLabel: task.action_label,
  article: {
    id: task.action_id === 1 || task.action_id === 2 ? task.article_id : task.story_id,
    title: task.action_id === 1 || task.action_id === 2 ? task.article_title : task.story_title,
    content: task.action_id === 1 || task.action_id === 2 ? task.article_content : null,
    image_url: task.action_id === 1 || task.action_id === 2 ? task.article_image : task.story_image,
  },
  actionId: task.action_id,
  userId: task.user_id,
});

export const fromTaskDTO = (task: any) => ({
  id: task.id,
  planned: toUTCDate(task.datetimePlanned).toISOString().slice(0, 19).replace('T', ' '),
  action_label: task.actionLabel,
  article_id: (parseInt(task.actionId) === 1 || parseInt(task.actionId) === 2) ? task.article.id : null,
  story_id: (parseInt(task.actionId) === 3 || parseInt(task.actionId) === 4) ? task.article.id : null,
  article_title: task.article.title,
  article_content: task.article.content,
  article_image: task.article.image_url,
  action_id: task.actionId,
  user_id: task.userId,
});

export const fromTaskDTOCreate = (task: any): any => ({
  planned: toUTCDate(task.datetimePlanned).toISOString().slice(0, 19).replace('T', ' '),
  article_id: (parseInt(task.actionId) === 1 || parseInt(task.actionId) === 2) ? task.article.id : null,
  story_id: (parseInt(task.actionId) === 3 || parseInt(task.actionId) === 4) ? task.article.id : null,
  action_id: task.actionId,
  user_id: task.userId,
});
